import React from "react";

const PdfSection = () => {
  return (
    <iframe
      src="/prospectus.pdf"
      title="prospectus.pdf"
      className="w-screen h-screen"
    />
  );
};

export default PdfSection;